import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  padding: 0 40px 40px;
  display: flex;
  justify-content: center;
`;
